import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { CheckoutShoppingBagType } from 'types/checkout'
import { FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'

type Props = {
  shoppingBags: CheckoutShoppingBagType[]
}

const PrintOrderShoppingBags: FC<Props> = (props) => {
  const { shoppingBags } = props
  return (
    <FlexRow justifyContent={'start'}>
      <div className={styles.printOrder__shoppingBags__label}>
        <span>レジ袋</span>
        <span>：</span>
      </div>
      <Spacer size={4} axis={'horizontal'} />
      <span>
        {(() => {
          const selectedBags = shoppingBags.filter((bag) => bag.quantity > 0)
          return selectedBags.length === 0
            ? '無し'
            : selectedBags.map((bag) => bag.name + bag.quantity + '枚').join(', ')
        })()}
      </span>
    </FlexRow>
  )
}

export default PrintOrderShoppingBags
